import React, { useState } from 'react'; 
import { Link, useNavigate } from 'react-router-dom'; 
import { useAuth } from '../App'; 
import '../styles/Header.css'; 

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };


  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  }; 

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo">
            <h1>Sahayak</h1>
            <span className="tagline">Your Home Helper</span>
          </Link>
        </div>

        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? '✕' : '☰'}
        </div>

        <nav className="header-nav">
          {isAuthenticated ? (
            <div className={`nav-authenticated ${mobileMenuOpen ? 'active' : ''}`}>
              <Link to="/dashboard" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Dashboard</Link>
              
              {user?.role === 'customer' && (
                <>
                  <Link to="/helpers" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Find Helpers</Link>
                  <Link to="/my-bookings" className="nav-link" onClick={() => setMobileMenuOpen(false)}>My Bookings</Link>
                  <Link to="/my-subscriptions" className="nav-link" onClick={() => setMobileMenuOpen(false)}>My Subscriptions</Link>
                </>
              )}
              
              {user?.role === 'helper' && (
                <Link to="/my-bookings" className="nav-link" onClick={() => setMobileMenuOpen(false)}>My Jobs</Link>
              )}
              
              <div className="user-menu">
                <span className="user-greeting">Hi, {user?.name}</span>
                <div className="user-dropdown">
                  <Link to="/profile" className="dropdown-link" onClick={() => setMobileMenuOpen(false)}>Profile</Link>
                  <button onClick={() => { handleLogout(); setMobileMenuOpen(false); }} className="dropdown-button">
                    Logout
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className={`nav-guest ${mobileMenuOpen ? 'active' : ''}`}>
              <Link to="/login" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Login</Link>
              <Link to="/register" className="nav-button" onClick={() => setMobileMenuOpen(false)}>Get Started</Link>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header; 